import React from 'react'

import { CubeDownloadedOutline, Save } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import MenuItem from 'Pods/UnifiedNavigation/Shared/MenuItem/MenuItem'
import Section from 'Pods/UnifiedNavigation/Shared/Section/Section'

// Buyer library: purchases and wish list.
function BuyerSection({ locale = 'en' }) {
  const t = (key) => i18n.t(key, { ns: 'rails', lng: locale })

  return (
    <Section divided>
      <MenuItem
        title={t('navigation.user_menu.buyer.purchases')}
        url="/profile/purchases"
        svgComponent={CubeDownloadedOutline}
        dataName="Purchases"
      />
      <MenuItem
        title={t('navigation.user_menu.buyer.wishlist')}
        url="/3d-models?licenses%5B%5D=wish_list_only"
        svgComponent={Save}
        dataName="Wish List"
      />
    </Section>
  )
}

BuyerSection.propTypes = {
  locale: string,
}

export default BuyerSection
